/**
 * Created by Jerker Nord on 2022-11-08.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../../components/BasicBitmapCountUp";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {BenjiKIVWinConfigs, IWinRatioConfig} from "../../configs/BenjiKIVWinConfigs";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {gsap} from "gsap";

export class BenjiKIVTotalWinView extends PIXI.Container implements StageLayer {

    private static FADE_IN_TIME:number = 0.3;

    private _totalWinContainer:PIXI.Container;
    private _totalWinCountUp:BasicBitmapCountUp;
    private _fadeInTimeline:gsap.core.Timeline;
    private _fadeOutTimeline:gsap.core.Timeline;
    private _countUpTimeline:gsap.core.Timeline;
    private _totalWinAmount:number;
    private _winRatioConfig:IWinRatioConfig;
    private _playSound:boolean = true;
    private _showCountUp:boolean;
    private _endSoundPlayed:boolean;
    private _targetScale:number;

    constructor() {
        super();
        this.name = "BenjiKIVTotalWinView";
        this.init();
        if(BenjiKIV.model.isRestore) {
            this.setKeypadWin();
        }
    }

    private init() {
        this._totalWinContainer = new PIXI.Container();
        this._totalWinContainer.position.set(360, 360);
        this.addChild(this._totalWinContainer);

        this._totalWinCountUp = new BasicBitmapCountUp({
            fontName : BenjiKIVGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 90,
            tint : 0xffffff
        }, 720, new PIXI.Point(0.5, 0.5));
        this._totalWinCountUp.visible = false;
        this._totalWinCountUp.position.y = 50;
        this._totalWinContainer.addChild(this._totalWinCountUp);
    }

    private setKeypadWin():void {
        BenjiKIV.keypadPlugin.setWin(BenjiKIV.model.data.accumulatedRoundWin, BenjiKIV.model.showTotalWin, BenjiKIV.isWinBelowStake());
    }

    public getTotalWinTimeline(totalWin:number):gsap.core.Timeline {
        let yPosWays: number = 85,
            targetScale = 0.5;

        if(this._fadeOutTimeline && this._fadeOutTimeline.isActive()) {
            this._fadeOutTimeline.pause();
            this._fadeOutTimeline.kill();
        }

        this._totalWinAmount = totalWin;
        this._winRatioConfig = BenjiKIVWinConfigs.getWinRatioConfig();
        this._playSound = true;
        this._showCountUp = true;

        this._totalWinCountUp.scale.set(0.5, 0.5);

        if(this._winRatioConfig.type == BenjiKIVWinConfigs.SMALL) {
            yPosWays = 110;
            targetScale = 0.7;
        } else if(this._winRatioConfig.type == BenjiKIVWinConfigs.MEDIUM) {
            yPosWays = 120;
            targetScale = 0.8;
        } else if(this._winRatioConfig.type == BenjiKIVWinConfigs.LARGE) {
            yPosWays = 130;
            targetScale = 0.9;
        }
        this._targetScale = targetScale;

        if(BenjiKIV.isWinBelowStake() && (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL || BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN)) {
            this._playSound = false;
            this._showCountUp = false;
        }
        if(BenjiKIV.isWinBelowPlayedBetValue() && (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL || BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN)) {
            this._playSound = false;
            this._showCountUp = false;
        }
        if(BenjiKIV.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && BenjiKIV.model.data.mode !== BenjiKIVGameMode.NORMAL && this._totalWinAmount <= BenjiKIV.model.gameData.playedBetValue) {
            //We are in FS/SFS. Always play unless total win is less than base bet
            this._playSound = false;
            this._showCountUp = false;
        }
        this._endSoundPlayed = false;

        this._countUpTimeline = gsap.timeline();

        if(this._winRatioConfig.duration == 0) {
            if(this._showCountUp) {
                this._totalWinCountUp.getCountAnimation(this._totalWinAmount, this._totalWinAmount, this._winRatioConfig.duration);
                this._totalWinCountUp.scale.set(targetScale, targetScale);
                BenjiKIV.winWays.setYPosWays(yPosWays);
                BenjiKIV.winWays.showInitialWinWays();

                this.sumUpMultiplierCountUp();
            }
            this.setKeypadWin();
            if(this._playSound) {
                this._endSoundPlayed = true;
                BenjiKIV.soundPlayer.stopCountUp(this._winRatioConfig);
            }
        } else {
            if(this._playSound) {
                this._countUpTimeline.add(() => BenjiKIV.soundPlayer.startCountUp());
            }
            if(this._showCountUp) {
                this._countUpTimeline.add([
                    () => {
                        BenjiKIV.multiplierCountUp.setYPos(false, false);
                    },
                    this._totalWinCountUp.getCountAnimation(0, this._totalWinAmount, this._winRatioConfig.duration, true),
                    gsap.to(this._totalWinCountUp.scale, {
                        duration : this._winRatioConfig.duration,
                        x : targetScale,
                        y : targetScale,
                        ease : "power3.out"
                    })
                ], 0);
                this._countUpTimeline.add(() => {
                    this._totalWinCountUp.stopAt(this._totalWinAmount);
                    if(this._playSound) {
                        this._endSoundPlayed = true;
                        BenjiKIV.soundPlayer.stopCountUp(this._winRatioConfig);
                    }

                    BenjiKIV.winWays.setYPosWays(yPosWays);
                    BenjiKIV.winWays.showInitialWinWays();

                    BenjiKIV.multiplierCountUp.playFSCupAnimation();
                });
            }

            this._countUpTimeline.add(() => {
                this.setKeypadWin();
            });
        }

        if(this._showCountUp) {
            this._totalWinCountUp.alpha = 0;
            this._totalWinCountUp.visible = true;

            this._fadeInTimeline = gsap.timeline();
            this._fadeInTimeline.add([
                gsap.to(this._totalWinCountUp, {
                    duration : BenjiKIVTotalWinView.FADE_IN_TIME,
                    alpha : 1,
                    ease : "power3.out"
                })
            ]);

            if(this._countUpTimeline.totalDuration() === 0) {
                this._fadeInTimeline.add(() => this.fadeOutWinPres(0.5, 0), "+=0.5");
                return this._fadeInTimeline;
            } else {
                this._countUpTimeline.add(() => this.fadeOutWinPres(0.5, 0), "+=0.8");
                return this._countUpTimeline;
            }
        }

        return gsap.timeline();
    }

    private fadeOutWinPres(duration:number, delay:number):void {
        this._fadeOutTimeline = gsap.timeline({
            delay : delay
        });
        this._fadeOutTimeline.add([
            gsap.to(this._totalWinCountUp, {
                duration : duration,
                alpha : 0,
                ease : "power3.out"
            }),
            () => {
                BenjiKIV.winWays.hideInitialWinWays(duration);

                BenjiKIV.multiplierCountUp.hideAllMultipliers();
            }
        ]);

        this._fadeOutTimeline.add(() => {
            this._totalWinCountUp.visible = false;
        });
    }

    public hardAbort():void {
        if(this._fadeInTimeline && this._fadeInTimeline.isActive()) {
            this._fadeInTimeline.pause();
            this._fadeInTimeline.kill();

            this.setTotalWinForAbort();
            this.fadeOutWinPres(0.3, 0);
        }

        if(this._countUpTimeline && this._countUpTimeline.isActive()) {
            this._countUpTimeline.pause();
            this._countUpTimeline.kill();

            this.setKeypadWin();

            this.setTotalWinForAbort();
            this.fadeOutWinPres(0.5, 0.6);

            if(this._playSound && !this._endSoundPlayed) {
                this._endSoundPlayed = true;
                BenjiKIV.soundPlayer.stopCountUp(this._winRatioConfig);
            }
        }
    }

    private setTotalWinForAbort():void {
        this._totalWinCountUp.alpha = 1;
        this._totalWinCountUp.scale.set(this._targetScale);
        this._totalWinCountUp.visible = true;
        this._totalWinCountUp.stopAt(this._totalWinAmount);

        this.sumUpMultiplierCountUp();
    }

    private sumUpMultiplierCountUp(): void {
        BenjiKIV.multiplierCountUp.setYPos(false, false);
        BenjiKIV.multiplierCountUp.summariseMultiplierCountUp();
        BenjiKIV.multiplierCountUp.playFSCupAnimation();
    }
}